import type { AxiosError } from 'axios';
import type { DocumentPickerAsset } from 'expo-document-picker';
import type { ImagePickerAsset } from 'expo-image-picker';
import { Platform } from 'react-native';
import { createMutation } from 'react-query-kit';

import { client } from '@/api/common';
import { throwFriendlyApiError } from '@/api/common/utils';

type Variables = {
  reservationId: number;
  category: string;
  offenseDate: string;
  amount: number;
  images: ImagePickerAsset[] | DocumentPickerAsset[] | File[];
};
export type CreateIncidentalResponse = {};

export const useCreateIncidental = createMutation<
  CreateIncidentalResponse,
  Variables,
  AxiosError
>({
  mutationFn: async (variables) => {
    const formData = new FormData();

    formData.append('reservation_id', variables.reservationId.toString());
    formData.append('category', variables.category);
    formData.append('offense_date', variables.offenseDate.toString());
    formData.append('amount', variables.amount.toString());

    variables.images.forEach(
      (image: ImagePickerAsset | DocumentPickerAsset | File) => {
        if (Platform.OS === 'web') {
          formData.append('files[]', image);
        } else {
          formData.append('files[]', {
            uri: image.uri,
            name: image.fileName || image.name,
            type: image.mimeType || 'image/jpeg',
          });
        }
      }
    );

    return client({
      url: `v2/internal/partners/incidentals`,
      method: 'POST',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
      .then((response) => response.data)
      .catch((err: any) => {
        throwFriendlyApiError(err, 'submit incidental');
      });
  },
});
